"use strict";

var processInclude = require("base/util");

$(document).ready(function () {
    processInclude(require("./account/loyaltyAccount.js"));
    processInclude(require("./login/login"));
});
